module.exports = __webpack_public_path__ + "img/Card_2.ddc12e56.svg";